import { render, staticRenderFns } from "./WishlistGroupDropdown.vue?vue&type=template&id=0415339c"
import script from "./WishlistGroupDropdown.vue?vue&type=script&lang=js"
export * from "./WishlistGroupDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports